import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

interface HourSelectionProps {
    selectedHour: number | null;
    setSelectedHour: (hour: SelectChangeEvent<any>) => void;
    min: number;
    max: number;
    label: string;
    disabled?: boolean;
}

const allHoursPossible = [
    { value: 8, label: '8:00'},
    { value: 9, label: '9:00'},
    { value: 10, label: '10:00'},
    { value: 11, label: '11:00'},
    { value: 12, label: '12:00'},
    { value: 13, label: '13:00'},
    { value: 14, label: '14:00'},
    { value: 15, label: '15:00'},
    { value: 16, label: '16:00'},
    { value: 17, label: '17:00'},
    { value: 18, label: '18:00'},
    { value: 19, label: '19:00'},
    { value: 20, label: '20:00'},
    { value: 21, label: '21:00'},
    { value: 22, label: '22:00'},
    { value: 23, label: '23:00'},
    { value: 24, label: '24:00'},
    { value: 25, label: 'F'},
];

function HourSelection(props: HourSelectionProps) {
    return (
        <FormControl sx={{minWidth: 150}}>
            <InputLabel id="select-heure-debut-label">{props.label}</InputLabel>
            <Select
                disabled={props.disabled ?? false}
                labelId="select-heure-debut-label"
                id="select-heure-debut"
                value={props.selectedHour ?? ''}
                onChange={props.setSelectedHour}
                label={props.label}
                renderValue={(selected) => {
                    const selectedValue = selected as number | string | null | undefined;

                    if (typeof selectedValue !== 'number') {
                        return '';
                    }

                    const selectedItem = allHoursPossible.find((item) => item.value === selectedValue);
                    return selectedItem?.label ?? '';
                }}
            >
                {
                    (
                        allHoursPossible.filter(item => item.value >= props.min && item.value <= props.max)
                    )
                    .map(item => (
                        <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
}

export default HourSelection;
